/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_New_ButtonInputs */



/**
* | output |
* | --- |
* | "New API Key" |
*
* @param {Options_Api_Keys_New_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_new_button = /** @type {((inputs?: Options_Api_Keys_New_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_New_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvelle clé API")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer API-Schlüssel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuova chiave API")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый ключ API")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nueva clave API")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新 API 密钥")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいAPIキー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई एपीआई कुंजी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nova chave de API")
	return /** @type {LocalizedString} */ ("New API Key")
});